export default "__VITE_ASSET__BY67bTmC__"